export default {
  order_amount: 'Order Amount',
  transaction_fee_charge_mode: 'Transaction Fee Charge Mode',
  transaction_fee_charge_mode1: 'Charge to Merchant',
  transaction_fee_charge_mode2: 'Charge to Customer',
  merchant_main_name: 'Account Name',
  merchant_no: 'Merchant No',
  merchant_name: 'Merchant Name',
  merchant_type: 'Merchant Type',
  merchant_origin: 'Entry Channel',
  industry_category: 'TYPE OF BUSINESS/channel',
  add_merchant: 'Add Merchant',
  service_fee: 'Fee',
  settlement_bank: 'Bank Name',
  settlement_bank_account: 'Bank A/c Holder',
  settlement_bank_num: 'Bank A/c No',
  contract_effect_time: 'Contract Effective Date',
  contract_validity_start: 'Contract Start Time',
  contract_validity_end: 'Contract End Time',
  merchant_status: 'Contract Status',
  merchant_payment_type: 'Merchant Business Type',
  payment_combination: 'Payin Fee Rate',
  payout_combination: 'Payout Fee Rate',
  channel_fee_id: 'Channel Fee ID',
  payment_institution_name: 'Payin Institution',
  fee_type: 'Charge Type',
  payment_institution_contract_costs: 'Payin Institution Contract Costs',
  external_quotation: 'Unlock External Quotation',
  unlock_quotation: 'Unlock Quotation',
  fee_structure: 'Charge Mode',
  combination_name: 'Combination Name',
  available_channels: 'Available Channels',
  legal_person_name: 'Legal Person Name',
  legal_person_mobile: 'Legal Person Mobile',
  legal_person_id_num_type: 'Legal Person ID Num Type',
  legal_person_id_num: 'Legal Person ID Num',
  legal_person_email: 'Legal Person Email',
  contract_name: 'Contact Name',
  contract_mobile: 'Contact Mobile',
  contract_id_num_type: 'Contact ID Num Type ',
  contract_id_num: 'Contact ID Num ',
  contract_email: 'Contact Email ',
  legal_person_id_num_upload: 'Upload Legal Person Certificate photo',
  upload_id_face_card: 'Upload ID Face Card,,',
  upload_id_back_card: 'Upload ID Back Card,',
  contract_validity_period: 'Contract Validity Date',
  legal_person_id_num_info: 'Legal Person ID Num Info',
  add_merchant_app: 'Add App Config',
  update_merchant_app: 'Update App Config',
  merchant_app_detail: 'App Config Detail',
  callback_event_list: 'Callback Event List',
  app_name: 'App Name',
  appkey: 'AppId',
  app_secret: 'Secret Key',
  notice_webhook: 'Notice Webhook',
  qrcode_webhook: 'QR Code Webhook',
  transfer_webhook: 'Transfer Webhook',
  collect_url: 'Collect Webhook',
  validate_url: 'Validate Webhook',
  public_key: 'Public Key',
  shared_application_setting : 'Shared Application Setting',
  secret_key: 'Secret Key',
  white_ips: 'White IP',
  ips_tips: '(IPs are separated by commas without spaces)',
  account_open_time: 'Account Open Time',
  to: 'To',
  merchant_basic_info: 'Basic Merchant Information',
  account_name: 'Bank Account Holder',
  account_num: 'Bank Account No.',
  withdrawal_account: 'Cash Out Account No.',
  account_bank: 'Bank name',
  account_address: 'Bank Address',
  company_address: 'Company Address',
  bank_list: 'Bank List',
  recharge: 'Top Up',
  withdraw: 'Cash Out',
  account_balance: 'Account Balance',
  bank_payee: 'Payee Bank',
  payment_institution: 'Payin Institution',
  payout_institution: 'Payout Institution',
  choose_bank_payee: 'Choose Payee Bank',
  payment_channel: 'Payment Channel',
  receiving_channel: 'Receiving Channel',
  institute_name: 'Institute Name',
  level_id: 'level',
  institute_rate_type: 'Institute Rate Type',
  institute_cost: 'Institute Cost',
  institute_cost_step_begin: 'Step Begin',
  institute_cost_step_end: 'Step End',
  profile_pic: 'Profile Picture',
  merchant_logo: 'Merchant Logo',
  settlement_method: 'Settlement Method',
  notification_email: 'Notification Email',
  notification_phone: 'Notification Phone',
  jt_institute_way_code: 'Institute Way Code'
}
